/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

//import redux
import { useDispatch, useSelector } from "react-redux";
import {
  addNewLabel,
  beneCategories,
  removeNewLabel,
} from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { beneTxnMultiDeniedApproval } from "../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { schedulesTxnReject } from "../../../redux/features/scheduleTransaction";
import { viewAccountDetail } from "../../../redux/features/verifyPAN/verifyPAN";

//import utils
import useServiceChecker from "../../../components/ServiceChecker/index.jsx";
import UserDetailsPopup from "../../../components/Settings/User/UserDetailsPopup/index.jsx";
import CommonToast from "../../../components/_utils/CommonToast";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";

//import components
import { toast } from "react-toastify";
import ICONS from "../../../assets/Icons";
import FieldForceAccDetailPagePopup from "../../../components/FieldForceAccount/FieldForceAccDetailPagePopup";
import Loader from "../../../components/Loader/Index";
import CommonAccountApprovalCard from "../../../components/_utils/CommonAccountApprovalCard";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import CommonAssignLabelPopup from "../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import LargePopupRedirect from "../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopupWithInput from "../../../components/_utils/CommonSmallPopupWithInput";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import PaginationComponent from "../../../components/_utils/PaginationComponent";
import UniversalRefreshToast from "../../../components/_utils/UniversalRefreshToast";
import {
  filedForceApproval,
  filedForceDeniedAccount,
  filedForceRequiredApproval,
} from "../../../redux/features/accounts/fieldForceAccount";
import accountNameStandardised from "../../../utils/accountNamestandardised";
import BeneficiaryTransactionViewall from "../../Transactions/BeneficiaryTransactions/BeneficiaryTransactionViewall";
import ScheduleBeneficiaryTransactionViewSchedules from "../../Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionViewSchedules/index.jsx";

//Redux Imports

// copy 0f reimbusrement acccount only check all Api related to fieldforce
const FieldForceAccountSingleApproval = (props) => {
  const [, ensureAll] = useServiceChecker();
  const sidebarButtonRef = useRef(null);
  const sidebarRef = useRef(null);
  const searchBarRefAcc = useRef(null);
  const filterRef = useRef(null);
  const dropdownRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const dateRef = useRef(null);

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();

  const [allAccounts, setAllAccounts] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [showScheduleTxnPopup, setShowScheduleTxnPopup] = useState(false);
  const [deniedId, SetdeniedId] = useState(null);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [loading, setLoading] = useState({});
  const [labels, setLabels] = useState([]);
  const [lebalid, setlableid] = useState([]);
  const [currentPage, setCurrentPage] = useState(
    GlobalConfiguration.lengthCheckOne,
  );
  const [showLoader, setShowLoader] = useState(false);
  const [pageSize, setPageSize] = useState(
    PaginationConfiguration.paginationSmall,
  );
  const [openBeneAssociate, setOpenBeneAssociate] = useState(false);
  const [userpopup, setUserpopup] = useState(false);
  const [userid, setUserid] = useState("");

  const serviceCheckUser = JSON.parse(sessionStorage.getItem("response"))
    ?.employees?.id;

  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [panNumber, setPanNumber] = useState("");
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [isIfsc, setIsIfsc] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [mainData, setMainData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [currentCategory, setCurrentCategory] = useState("");
  const [LabelSearchText, setLabelSearchText] = useState([]);
  const [active, setActive] = useState("");
  const [declineReason, setDeclineReason] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [approveRejectBtnClicked, setApproveRejectBtnClicked] = useState({});
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const [selectedValue, setSelectedValue] = useState(
    dropdownOptions[GlobalConfiguration.lengthCheckZero],
  );
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [searchUserText, setSearchUserText] = useState("");
  const [associateType, setAssociateType] = useState("");
  const [activeType, setActiveType] = useState("pan");
  const [remAccount, setRemAccount] = useState("");
  const [remPan, setRemPan] = useState("");
  const [remIFSC, setRemIFSC] = useState("");
  const [associatePopupDate, setAssociatePopupDate] = useState({
    panNumber: "",
    ifscCode: "",
    accNumber: "",
    accId: "",
    accName: "",
  });
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [fieldForceAccountDetailsId, setFieldForceAccountDetailsId] =
    useState(null);

  const {
    fieldforceDeniedApprovalLoading,
    fieldforceWaitingApprovalData,
    fieldforceRequiredApprovalData,
  } = useSelector((state) => state.fieldForceAccount);
  const { schedulesTxnViewAllData, schedulesTxnViewAllLoading } = useSelector(
    (state) => state?.schedulesTxnSlice,
  );

  // (counts were unused in UI; removed)

  // const { filedForceApproval } = useSelector((state) => {
  //   return state.fieldForceAccount;
  // });
  const services = useSelector((state) => state.refreshToken.services);

  const { beneTxnViewAllAccLoading, beneTxnViewAllAccData } = useSelector(
    (state) => state?.beneTxnViewAccData,
  );

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const updateIsFilterApplied = () => {};
  const hasAnyFilter =
    Boolean(currentCategory?.length) ||
    Boolean(LabelSearchText?.length) ||
    Boolean(accountNumber?.length) ||
    Boolean(panNumber?.length) ||
    Boolean(searchUserText?.length) ||
    (startDateFilter !== "" &&
      endDateFilter !== "" &&
      startDateFilter !== GlobalConfiguration.lengthCheckZero &&
      endDateFilter !== GlobalConfiguration.lengthCheckZero &&
      !isNaN(Number(startDateFilter)) &&
      !isNaN(Number(endDateFilter))) ||
    Boolean(isIfsc) ||
    Boolean(searchUserTextDebounce?.length);

  const noTransactionsFromAPI =
    !allBeneTxnAccountsLoading &&
    mainData &&
    mainData.total_count === GlobalConfiguration.lengthCheckZero &&
    !hasAnyFilter;

  const noResultsAfterFilter =
    !allBeneTxnAccountsLoading &&
    accumulatedData?.length === GlobalConfiguration.lengthCheckZero &&
    hasAnyFilter;

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handlePagination = (page) => {
    setCurrentPage(page);
  };
  const searchBarRefAcc2 = useRef(null);
  const updateAllAccounts = (updatedAccounts) => {
    setAllAccounts(updatedAccounts);
  };
  const handleInputChange = (event) => {
    const value = event?.target?.value || "";

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    if (sanitizedValue.length <= GlobalConfiguration.inputMaxLength) {
      setDeclineReason(sanitizedValue);
    }
  };

  const fetchData2 = async () => {
    let response;
    let data = [];
    setLoadingData(true);

    switch (active) {
      case "Category":
        response = await dispatch(
          beneCategories({ search_string: searchUserTextDebounce }),
        );
        data = response?.payload?.categories?.map((itm) => {
          return {
            id: itm.name,
            Category: itm.name,
            Description: itm?.description || "Not given",
          };
        });
        setInputData(data);
        setLoadingData(false);
        break;
      case "Labels":
        data =
          labels
            ?.filter((itm) => itm.includes(searchUserTextDebounce))
            ?.map((val) => ({ id: val, Label: val })) || [];
        setInputData(data);
        setLoadingData(false);
        break;
      default:
        break;
    }
  };

  const fetchData = async () => {
    try {
      setAllBeneTxnAccountsLoading(true);

      await dispatch(beneCategories());

      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
        type:
          props?.internalAccount === "internalAccount"
            ? "internalAccount"
            : undefined,
        // search_string: searchUserText,
      };
      if (currentCategory !== "") {
        queryParams.categoryName = currentCategory;
      }
      if (
        startDateFilter !== "" &&
        endDateFilter !== "" &&
        startDateFilter !== GlobalConfiguration.lengthCheckZero &&
        endDateFilter !== GlobalConfiguration.lengthCheckZero &&
        !isNaN(Number(startDateFilter)) &&
        !isNaN(Number(endDateFilter))
      ) {
        queryParams.start_date = startDateFilter + 86400;
        queryParams.end_date = endDateFilter + 86400;
      }
      if (accountNumber !== "") {
        queryParams.bank_account_no = accountNumber;
      }
      if (currentCategory !== "") {
        queryParams.categoryName = currentCategory;
      }

      if (panNumber !== "") {
        queryParams.pan = panNumber;
      }
      if (searchUserText !== "") {
        queryParams.search_string = searchUserText;
      }
      if (LabelSearchText?.length !== GlobalConfiguration.lengthCheckZero) {
        queryParams.labels = LabelSearchText;
      }
      if (isIfsc !== "") {
        queryParams.ifsc = isIfsc;
      }

      const response = await dispatch(filedForceRequiredApproval(queryParams));

      const newData = (response?.payload?.field_force_accounts || []).map(
        (account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
        }),
      );

      setAllAccounts(() => [...newData]);
      setMainData(response?.payload);
      setLabels(response?.payload?.summary?.available_labels);

      const rawData = response?.payload?.field_force_accounts || [];
      setAccumulatedData(rawData);
    } catch (error) {
      console.error("Error fetching beneficiary accounts:", error);
    } finally {
      setAllBeneTxnAccountsLoading(false);
    }
  };

  const handleDateChange = (date) => {
    if (date) {
      const [start, end] = date;
      setStartDateFilter(convertDate(start));
      setEndDateFilter(convertDate(end));
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(Number(currentPage));
    toggleDropdown();
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setAllBeneTxnAccountsLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(lebalid);
    const res = await dispatch(
      addNewLabel({ record_ids: recordIds, labels: labelsToAssign }),
    );
    if (addNewLabel?.fulfilled?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addNewLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setAllBeneTxnAccountsLoading(false);
    if (addNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setAllBeneTxnAccountsLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(lebalid);
    const res = await dispatch(
      removeNewLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeNewLabel?.fulfilled?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeNewLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setAllBeneTxnAccountsLoading(false);
    if (removeNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const filteredData = accumulatedData;

  const handleOpenPopup = (id) => {
    setShowPopup(true);
    SetdeniedId(id);
  };

  const handleClosePopup = (deniedId) => {
    setApproveRejectBtnClicked({
      ...approveRejectBtnClicked,
      [deniedId]: "none",
    });
    setShowPopup(false);
    setDeclineReason("");
    setShowRejectPopup(false);
    setShowScheduleTxnPopup(false);
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    if (labelActionDispatchedRef.current) {
      fetchData();
      labelActionDispatchedRef.current = false;
    }
  };

  const handleCloseModal = () => {
    setOpenBeneAssociate(false);
  };
  const openFieldForceAccountDetailModal = (accountId) => {
    setFieldForceAccountDetailsId(accountId);
    setIsDrawerOpen(true);
  };

  const closeFieldForceAccountDetailModal = () => {
    setIsDrawerOpen(false);
    setFieldForceAccountDetailsId(null);
  };

  const onClose = () => {
    setShowRejectPopup(false);
  };

  const handleApprovalToastSuccess = () => {
    CommonToast({
      text: "Account approved successfully.",
      icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
      variant: "var(--success)",
    });
  };

  const handleApproval = async (id) => {
    setLoading((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true,
    }));
    UniversalRefreshToast("approvalaccountsRefresh");

    const data = await dispatch(filedForceApproval(id));

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "FFAAccount",
        },
      });
      return;
    }

    let errorMessage = "";
    if (data) {
      const errors = data?.payload?.errors;

      if (errors?.field_force_accounts?.[GlobalConfiguration.lengthCheckZero]) {
        errorMessage =
          errors.field_force_accounts[GlobalConfiguration.lengthCheckZero];
      } else if (
        errors?.bank_account_number?.[GlobalConfiguration.lengthCheckZero]
      ) {
        errorMessage =
          errors.bank_account_number[GlobalConfiguration.lengthCheckZero];
      } else if (!data?.payload?.status) {
        errorMessage = errors?.category?.[GlobalConfiguration.lengthCheckZero];
      } else {
        errorMessage = "An unknown error occurred.";
      }
    }

    if (data) {
      const updatedData = allAccounts.map((item) => {
        if (item.id === id) {
          let lifecycleStatus = "";

          if (data.payload.status === true) {
            lifecycleStatus = "Approved";
          }
          if (data.payload.status === false) {
            lifecycleStatus = "error";
          }

          let message = "";
          if (data.payload.status === false) {
            const errors = data?.payload?.errors;
            if (
              errors?.field_force_accounts?.[
                GlobalConfiguration.lengthCheckZero
              ]
            ) {
              message =
                errors.field_force_accounts[
                  GlobalConfiguration.lengthCheckZero
                ];
            } else if (data?.payload?.errors === "false") {
              message = errors?.category?.[GlobalConfiguration.lengthCheckZero];
            } else if (
              errors?.bank_account_number?.[GlobalConfiguration.lengthCheckZero]
            ) {
              message =
                errors.bank_account_number[GlobalConfiguration.lengthCheckZero];
            }
          }

          return {
            ...item,
            approval_status:
              item.approval_status === "pending" ? lifecycleStatus : "pending",
            error:
              item.error === "false" && data?.payload.status === false
                ? "true"
                : "false",
            message:
              item.message === "" && data.payload.status === false
                ? message
                : "",
          };
        }

        return item;
      });

      setAllAccounts(updatedData);

      if (data?.payload.status === false) {
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
        });
      }
    }

    setTimeout(() => {
      setLoading((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false,
      }));
    }, IntervalConfiguration.intervalExtraLarge);

    setTimeout(() => {
      if (data.payload.status === true) {
        toast.dismiss();
        handleApprovalToastSuccess();
      }
    }, IntervalConfiguration.intervalExtraLarge);
  };

  // Removed unused counters and dead "more details" popup handler.
  // Removed drawer-based "more details" modal (unused).

  const openTxnPopup = (id, acc_Name) => {
    setAssociatePopupDate((prev) => {
      return {
        ...prev,
        accId: id,
        accName: acc_Name,
      };
    });
  };

  const handleClearFilters = () => {
    setStartDateFilter("");
    setSearchUserText("");
    setEndDateFilter("");
    setShowSearchBar(false);
    setCurrentCategory("");
    setPanNumber("") ||
      setAccountNumber("") ||
      setIsIfsc("") ||
      setLabelSearchText("");
    setSearchUserTextDebounce("");
  };

  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    // setShowLoader(true);
    setShowPopup(false);

    const accountInfo = await dispatch(viewAccountDetail({ id: deniedId }));

    if (
      accountInfo?.payload?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ]?.pending_transactions === "Y" &&
      (accountInfo?.payload?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ]?.pending_scheduled_transactions === "Y" ||
        accountInfo?.payload?.field_force_accounts?.[
          GlobalConfiguration.lengthCheckZero
        ]?.pending_scheduled_transactions === "N")
    ) {
      setShowRejectPopup(true);
    } else if (
      accountInfo?.payload?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ]?.pending_transactions === "N" &&
      accountInfo?.payload?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ]?.pending_scheduled_transactions === "Y"
    ) {
      setShowScheduleTxnPopup(true);
    } else {
      handleConfirm(id, AccountIdData);
    }
  };

  const handleConfirm = async (id, AccountIdData) => {
    setShowLoader(true);

    UniversalRefreshToast("accountsRefresh");

    if (
      !fieldforceDeniedApprovalLoading ||
      fieldforceDeniedApprovalLoading === null
    ) {
      const result = await dispatch(
        filedForceDeniedAccount({ id, AccountIdData }),
      );

      await new Promise((resolve) =>
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
      );

      if (result?.payload?.status === false) {
        let error_msg = "";

        if (
          result?.payload?.errors?.field_force_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          error_msg =
            result?.payload?.errors?.field_force_accounts[
              GlobalConfiguration.lengthCheckZero
            ];
        } else if (
          result?.payload?.errors?.bank_account_number?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          error_msg =
            result?.payload?.errors?.bank_account_number[
              GlobalConfiguration.lengthCheckZero
            ];
        } else if (!result?.payload?.status) {
          error_msg =
            result?.payload?.errors?.category?.[
              GlobalConfiguration.lengthCheckZero
            ];
        } else {
          error_msg = "An unknown error occurred.";
        }

        const updatedData = allAccounts?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "error" : "pending",
              rejected_on: "",
              rejected_by_name: "",
              rejection_reason: AccountIdData,
              error: "true",
              message: error_msg,
              pending_transactions: "N",
              pending_scheduled_transactions: "N",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);

        setShowLoader(false);
        setShowPopup(false);
        setDeclineReason("");
        onClose();
        CommonToast({
          text: error_msg,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
        });
      } else {
        const updatedData = allAccounts.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status: "rejected",
              rejected_on:
                result?.payload?.field_force_accounts?.[
                  GlobalConfiguration.lengthCheckZero
                ]?.rejected_on ?? "",
              rejected_by_name:
                result?.payload?.field_force_accounts?.[
                  GlobalConfiguration.lengthCheckZero
                ]?.rejected_by_name ?? "",
              rejection_reason: AccountIdData,
              error: "false",
              message: "",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);
        setShowLoader(false);
        setDeclineReason("");
        setAssociateType("");
        onClose();
        setShowPopup(false);
        CommonToast({
          text: "Account rejected successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
        });
      }
    }
    setApproveRejectBtnClicked((prev) => ({ ...prev, [id]: "none" }));
  };

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );
    return timestamp;
  };

  const handleRejectBeneTxn = async () => {
    setShowLoader(true);

    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !beneTxnViewAllAccLoading &&
      beneTxnViewAllAccData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? beneTxnViewAllAccData?.transactions.map((data) => data?.txn_id)
        : [];

    UniversalRefreshToast("Rejecting transaction");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        beneTxnMultiDeniedApproval({ id: id2, AccountIdData }),
      );
    } else {
      data = { payload: { status: true } };
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      const serviceKey = "ABeneficiaryTxn";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[
            GlobalConfiguration.lengthCheckZero
          ]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(
              data?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
                ?.errors,
            )
          ? data.payload.errors.base[GlobalConfiguration.lengthCheckZero]
              .errors[GlobalConfiguration.lengthCheckZero]
          : data?.payload?.errors?.base?.[
              GlobalConfiguration.lengthCheckZero
            ] || "Unknown error occurred";
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      setShowLoader(false);
    } else if (data?.payload?.status === true) {
      setShowRejectPopup(false);
      CommonToast({
        text: "Transaction rejected successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      const updatedData = allAccounts?.map((item) => {
        if (item.id === associatePopupDate?.accId) {
          return {
            ...item,
            pending_transactions: "N",
          };
        }
        return item;
      });

      if (associateType === "rejectAccount") {
        allAccounts?.forEach((item) => {
          if (item.id === associatePopupDate?.accId) {
            if (item?.pending_scheduled_transactions === "Y") {
              setTimeout(() => {
                setShowScheduleTxnPopup(true);
              }, IntervalConfiguration.intervalMedium);
            } else {
              handleConfirm(deniedId, declineReason);
            }
          }
        });
      }

      updateAllAccounts(updatedData);
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
    setTimeout(() => {
      setShowRejectPopup(false);
    }, IntervalConfiguration.intervalMedium);
    if (associateType !== "rejectAccount") {
      setDeclineReason("");
      setAssociateType("");
    }
    setShowLoader(false);
    setShowPopup(false);
  };

  const handleRejectScheduleTxn = async () => {
    const AccountIdData = declineReason;

    let id2 =
      !schedulesTxnViewAllLoading &&
      schedulesTxnViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? schedulesTxnViewAllData?.transactions.map((data) => data?.txn_id)
        : [];
    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      let data2 = await dispatch(
        schedulesTxnReject({
          id: id2,
          reason: AccountIdData,
          services,
        }),
      );
      if (data2?.payload?.status === false) {
        const error_msg2 = data2?.payload?.errors?.user_unauthorized
          ? data2?.payload?.errors?.user_unauthorized[
              GlobalConfiguration.lengthCheckZero
            ]
          : Array.isArray(data2?.payload?.errors?.base) &&
              Array.isArray(
                data2?.payload?.errors?.base[
                  GlobalConfiguration.lengthCheckZero
                ]?.errors,
              )
            ? data2.payload.errors.base[GlobalConfiguration.lengthCheckZero]
                .errors[GlobalConfiguration.lengthCheckZero]
            : data2?.payload?.errors?.base?.[
                GlobalConfiguration.lengthCheckZero
              ] || "Unknown error occurred";
        CommonToast({
          text: error_msg2,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setTimeout(() => {
          setShowScheduleTxnPopup(false);
        }, IntervalConfiguration.intervalMedium);

        setShowLoader(false);
      } else if (data2?.payload?.status === true) {
        setShowScheduleTxnPopup(false);
        CommonToast({
          text: "Scheduled transactions rejected successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        setTimeout(() => {
          setShowScheduleTxnPopup(false);
        }, IntervalConfiguration.intervalMedium);

        const updatedData = allAccounts?.map((item) => {
          if (item.id === associatePopupDate?.accId) {
            return {
              ...item,
              pending_scheduled_transactions: "N",
            };
          }
          return item;
        });

        updateAllAccounts(updatedData);
        // fetchData();

        if (associateType === "rejectAccount") {
          handleConfirm(deniedId, declineReason);
        }
      }
      setDeclineReason("");
      setAssociateType("");
      setShowPopup(false);
    }
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    if (active?.length) {
      fetchData2();
    }
  }, [active]);

  useEffect(() => {
    fetchData();
  }, [
    currentPage,
    pageSize,
    startDateFilter,
    endDateFilter,
    accountNumber,
    panNumber,
    searchUserText,
    isIfsc,
    currentCategory,
    LabelSearchText,
    markerData,
  ]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [startDateFilter, endDateFilter]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAcc2.current &&
        !searchBarRefAcc2.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }

      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        !(dateRef.current && dateRef.current.contains(event.target))
      ) {
        // no-op (date picker removed)
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }

      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        sidebarButtonRef.current &&
        !sidebarButtonRef.current.contains(event.target)
      ) {
        setIsSidebarOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <>
      {userpopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-max-zindex bg-custom-backdrop bg-opacity-dark-opacity">
          <UserDetailsPopup
            User_account_id={userid}
            type={"User_details"}
            closeBeneAccountDetailModal={() => {
              setUserpopup(false);
            }}
          />
        </div>
      )}

      {isLabelPopupOpen && (
        <div
          onClick={() => {
            setIsLabelPopupOpen(false);
          }}
          className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex"
          max-zindex
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated accounts."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={lebalid}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={(filteredData || []).filter((acc) =>
              Array.isArray(lebalid)
                ? lebalid.includes(acc?.id)
                : lebalid === acc?.id,
            )}
            type={
              props?.internalAccount === "internalAccount" ? "internal" : "bene"
            }
            onClose={handleClose}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            loading={allBeneTxnAccountsLoading}
            setLoading={setAllBeneTxnAccountsLoading}
          />
        </div>
      )}

      {showRejectPopup && (
        <div className="fixed top-top-base left-laft_base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop">
          <LargePopupRedirect
            headerTitle="Associated transactions found"
            headersubtext="The following transactions are linked and need to be rejected before rejecting this account."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setApproveRejectBtnClicked({
                ...approveRejectBtnClicked,
                [deniedId]: "none",
              });
              setShowRejectPopup(false);
            }}
            closeicon={
              "https://q2pay.in/new_assets/common/create_flow/close.svg"
            }
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText={
              "To reject the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason."
            }
            isbottomSectionneed={true}
            btnText={"Reject all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              if (associateType === "BeneTxn") {
                setShowRejectPopup(false);
                setShowPopup(true);
              } else {
                handleRejectBeneTxn();
              }
            }}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor={""}
            disabledBgColor={""}
          >
            <BeneficiaryTransactionViewall
              bene_account_id={associatePopupDate?.accId}
              typepop={"BeneAccRejectTxn"}
              closeRejectAllTxn={handleClosePopup}
              bene_account_name={associatePopupDate?.accName}
            />
          </LargePopupRedirect>
        </div>
      )}

      {/* Reject schedule beneficiary transactions */}
      {showScheduleTxnPopup && (
        <div className="fixed top-top-base left-laft_base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop">
          <LargePopupRedirect
            headerTitle="Associated schedules found"
            headersubtext="The following schedules are linked and need to be rejected before rejecting this account."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => setShowScheduleTxnPopup(false)}
            closeicon={
              "https://q2pay.in/new_assets/common/create_flow/close.svg"
            }
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText={
              "To reject the account, please reject the schedules listed above by clicking the “Reject all” button. The schedules will get rejected with the provided rejected reason."
            }
            isbottomSectionneed={true}
            btnText={"Reject all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              if (associateType === "scheduleBeneTxn") {
                setShowScheduleTxnPopup(false);
                setShowPopup(true);
              } else {
                handleRejectScheduleTxn();
              }
            }}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor={""}
            disabledBgColor={""}
          >
            <ScheduleBeneficiaryTransactionViewSchedules
              type={"ScheduleAccBeneAcc"}
              payload={{
                schedule_acc_id: associatePopupDate?.accId,
                schedule_acc_name: associatePopupDate?.accName,
              }}
              closeCallback={handleClosePopup}
            />
          </LargePopupRedirect>
        </div>
      )}

      {/* Popup for entering reason for declining account & transaction */}
      {showPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Please state the reason for rejecting the account."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            // noteText="The reason must consist of at least 10 characters."
            noteColor="text-secondary"
            inputPlaceholder="Reason (10-150 char)"
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            // End of Input Field Props
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              // if (!showLoader) {

              handleClosePopup(deniedId);

              // }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              if (associateType === "scheduleBeneTxn") {
                handleRejectScheduleTxn();
              } else if (associateType === "BeneTxn") {
                handleRejectBeneTxn();
              } else {
                handleRejectTransactionChecker(deniedId, declineReason);
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration.panLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}

      {/* Removed unused account details drawer modal */}
      {isDrawerOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
          <FieldForceAccDetailPagePopup
            closeFieldForceAccountDetailModal={
              closeFieldForceAccountDetailModal
            }
            field_force_account_id={fieldForceAccountDetailsId}
            type="field_force_account_detail_modal"
          />
        </div>
      )}

      {/* Entire page */}
      <div
        className={` h-screen overflow-hidden flex flex-col ${showInnerSearchBar && " bg-PopUp-BackDrop"}`}
      >
        <div className=" relative z-z-index-overlay bg-primary-nav min-h-0 Qmd:min-h-navbar-breadcrumb-height">
          {" "}
        </div>

        <div className=" w-full relative z-z-index-header lg:px-padding-base  flex items-center justify-end m-auto ">
          <TopNavComponent
            handleBack={() => {
              navigate(GlobalConfiguration.navigate_back);
            }}
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: allBeneTxnAccountsLoading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search field force account",
              filterPlaceholder:
                "name / contact number / email ID / account ID",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: setSearchUserText,
                  isDropdown: false,
                  isDisabled: false,
                },
                {
                  name: "Account number",
                  short_name: "Field force A/c",
                  isMulti: false,
                  value: accountNumber,
                  setValue: setAccountNumber,
                  isDropdown: false,
                  valueType: "string",
                  isDisabled: false,
                },
                {
                  name: "IFSC code",
                  short_name: "IFSC",
                  isMulti: false,
                  value: isIfsc,
                  setValue: setIsIfsc,
                  isDropdown: false,
                  valueType: "string",
                  isDisabled: false,
                },
                {
                  name: "PAN number",
                  short_name: "PAN",
                  isMulti: false,
                  value: panNumber,
                  setValue: setPanNumber,
                  isDropdown: false,
                  valueType: "string",
                  isDisabled: false,
                },
                {
                  name: "Category",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  setValue: setCurrentCategory,
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: false,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  // filterType: "",
                  // size: "small",
                  // isMulti: true,
                  // value: startDateFilter && endDateFilter,
                  // isDisable: false,
                  // handleChange: (date) => handleDateChange(date),
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: setLabelSearchText,
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: false,
                },
                // {
                //   name: "24 hour transaction limit",
                //   short_name: "Transaction limit",
                //   isMulti: false,
                //   value: transaction_limit,
                //   setValue: setTransaction_limit,
                //   isDropdown: false,
                //   valueType: "string",
                //   isDisabled: false,
                // },
              ],
              filters: [
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => handleDateChange(date),
                },
              ],
              isFilterClearAllDisabled: !(startDateFilter && endDateFilter),
              isSearchClearAllDisabled: !(
                currentCategory !== "" ||
                panNumber !== "" ||
                LabelSearchText?.length !==
                  GlobalConfiguration.lengthCheckZero ||
                isIfsc !== "" ||
                searchUserText !== "" ||
                accountNumber !== ""
              ),

              inputData: inputData,
              active: active,
              setActive: setActive,
              loadingData: loadingData,
              loading: allBeneTxnAccountsLoading,
              setLoading: setLoadingData,
              isShowFilter: true,
            }}
          />
        </div>
        <div
          style={{ marginBottom: "var(--pagination-height)" }}
          className={`flex-1 flex flex-col overflow-hidden relative ${showInnerSearchBar ? "pointer-events-none" : ""}`}
        >
          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-content "></div>
          )}
          <div
            style={{
              paddingBottom:
                fieldforceRequiredApprovalData?.summary
                  ?.pending_accounts_count === undefined && "var(--padding-md)",
            }}
            className={`flex flex-col flex-1 items-center overflow-auto overflow-x-hidden w-full pb-padding-lg ${allBeneTxnAccountsLoading ? "h-full" : ""} `}
          >
            {allBeneTxnAccountsLoading ? (
              <div className="loader-container m-auto justify-center items-center flex">
                <Loader />
              </div>
            ) : noResultsAfterFilter ? (
              <div className="flex flex-col items-center justify-center m-auto w-full h-full">
                <img
                  src={
                    "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                  }
                  alt="No accounts found"
                  className={"w-graphic-width-md h-graphic-rectangle-height-md"}
                />
                <p className="bene-acc-no-beneaccount-text my-margin-sm">
                  No data found.
                </p>

                <PrimaryButton
                  enabledBgColor="var(--primary-nav-act)"
                  btnText="Clear parameters"
                  btnType="button"
                  handleFunction={handleClearFilters}
                  enabledTextColor="var(--text-primary)"
                />
              </div>
            ) : allAccounts?.length > GlobalConfiguration.lengthCheckZero ? (
              <div
                className="scroll flex flex-col items-center justify-center w-width-full z-z-index-base"
                ref={filterRef}
              >
                <div className="scroll flex flex-col items-center justify-center w-width-full lg:w-auto px-padding-md lg:px-padding-base  gap-gap-md">
                  {allAccounts?.map((account, index) => {
                    return (
                      <div
                        key={account.id}
                        className={`w-full ${index === GlobalConfiguration.lengthCheckZero ? "mt-margin-md" : ""}`}
                      >
                        <CommonAccountApprovalCard
                          overrideAutoLoader
                          whichBtnClicked={
                            approveRejectBtnClicked?.[account.id] ?? "none"
                          }
                          entries={[
                            [
                              {
                                type: "textSubtext",
                                text: accountNameStandardised(account.name),
                                subText: "Account name",
                              },
                              {
                                type: "textSubtext",
                                text: account.email_id,
                                subText: "Email ID",
                              },
                              {
                                type: "textSubtext",
                                text: "+91 " + account.contact_no,
                                subText: "Contact number",
                              },
                              {
                                type: account?.field_force_user_full_name
                                  ? "cta"
                                  : "textSubtext",
                                text: account?.field_force_user_full_name
                                  ? accountNameStandardised(
                                      account.field_force_user_full_name,
                                    )
                                  : "Not Linked",
                                subText: "Linked user",
                                onClick: () => {
                                  if (!account?.field_force_user_full_name)
                                    return;

                                  const hasVSpecificEmp = ensureAll([
                                    "VSpecificEmp",
                                  ])?.status;

                                  const hasAdmin = ensureAll(["Admin"])?.status; // keep "Admin" case

                                  const canViewLinkedUser =
                                    (hasVSpecificEmp &&
                                      account?.field_force_user_id ===
                                        serviceCheckUser) ||
                                    (hasVSpecificEmp && hasAdmin);

                                  if (canViewLinkedUser) {
                                    setUserpopup(true);
                                    setUserid(account?.field_force_user_id);
                                    return;
                                  }

                                  const unavailableService = !hasVSpecificEmp
                                    ? "VSpecificEmp"
                                    : !hasAdmin
                                      ? "Admin"
                                      : "VSpecificEmp";

                                  navigate("/feature_not_assigned", {
                                    state: { unavailableService },
                                  });
                                },
                              },
                            ],

                            [
                              {
                                type: "textSubtext",
                                text: accountNameStandardised(
                                  account.bank_account_holder_full_name,
                                ),
                                subText: "Bank account holder name ",
                              },
                              {
                                type: "accountNumber",
                                text: account.bank_acc_no,
                                subText: "Account number",
                                ifsc: account.ifsc_code,
                              },
                              {
                                type: "textSubtextX2",
                                text: account.ifsc_code,
                                subText: "IFSC code",
                                text1:
                                  account?.virtual_account === "N"
                                    ? ""
                                    : account?.virtual_account_type === "manual"
                                      ? "Manually created"
                                      : account?.virtual_account_type ===
                                          "automated" && "Auto detected",
                                subText1:
                                  account?.virtual_account === "N"
                                    ? ""
                                    : "Virtual account",
                              },
                              {
                                type: "textSubtextX2",
                                text: account.pan_no,
                                subText: "PAN number",
                                text1: account.gstin_detail || "Not given",
                                subText1: "GST number",
                              },
                            ],

                            [
                              {
                                type: "cta",
                                text:
                                  account?.labels?.join(", ") ||
                                  "No labels assigned",
                                subText: "Assigned labels",
                                onClick: (e) => {
                                  if (
                                    services?.includes("ALabel") &&
                                    services?.includes("RLabel")
                                  ) {
                                    e.stopPropagation();
                                    setlableid(account?.id);
                                    setIsLabelPopupOpen(true);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "ALabel,RLabel",
                                      },
                                    });
                                  }
                                },
                              },
                              {
                                type: "textSubtext",
                                text: account?.category || "Not Assigned",
                                subText: "Assigned categories",
                              },
                            ],
                          ]}
                          approveClick={() => {
                            setApproveRejectBtnClicked({
                              ...approveRejectBtnClicked,
                              [account.id]: "approve",
                            });
                            handleApproval(account.id);
                          }}
                          rejectClick={() => {
                            setApproveRejectBtnClicked({
                              ...approveRejectBtnClicked,
                              [account?.id]: "reject",
                            });
                            handleOpenPopup(account?.id);
                            openTxnPopup(account?.id, account?.name);
                            setAssociateType("rejectAccount");
                          }}
                          ctaBtn1Text={"More details"}
                          ctaBtn1OnClick={() =>
                            openFieldForceAccountDetailModal(account.id)
                          }
                          cardState={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            fieldforceWaitingApprovalData &&
                            !loading[account.id]
                              ? "single"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? account.rejection_reason
                                  ? "double"
                                  : "single"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "single"
                                  : "default"
                          }
                          overlay1Text={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            fieldforceWaitingApprovalData &&
                            !loading[account.id]
                              ? "Approved"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "Rejected"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "Failed to take action!"
                                  : undefined
                          }
                          overlay1Subtext={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            fieldforceWaitingApprovalData &&
                            !loading[account.id]
                              ? "This account has been approved."
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "This account has been rejected."
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? account.message ||
                                    "An error occurred while taking action on this account."
                                  : undefined
                          }
                          overlay1Icon={
                            account.approval_status === "Approved" &&
                            account.error === "false" &&
                            fieldforceWaitingApprovalData &&
                            !loading[account.id]
                              ? "https://q2pay.in/new_assets/common/approval/approved_linear_green.svg"
                              : account.approval_status === "rejected" &&
                                  account.error === "false" &&
                                  !loading[account.id]
                                ? "https://q2pay.in/new_assets/common/approval/rejected_red.svg"
                                : account.approval_status === "error" &&
                                    account.error === "true" &&
                                    !loading[account.id]
                                  ? "https://q2pay.in/new_assets/common/create_flow/error_with_white_outlined_circle.svg"
                                  : undefined
                          }
                          overlay1CtaText={
                            (account.approval_status === "Approved" &&
                              account.error === "false" &&
                              fieldforceWaitingApprovalData &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status === "rejected" &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? "View account"
                              : undefined
                          }
                          overlay1CtaOnClick={
                            (account.approval_status === "Approved" &&
                              account.error === "false" &&
                              fieldforceWaitingApprovalData &&
                              !loading[account.id]) ||
                            (account.approval_status === "error" &&
                              account.error === "true" &&
                              !loading[account.id]) ||
                            (account.approval_status === "rejected" &&
                              account.error === "false" &&
                              !loading[account.id])
                              ? () => {
                                  navigate(
                                    `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${account.id}`,
                                    {
                                      state: {
                                        isViewAll:
                                          location.pathname.includes(
                                            "view_all",
                                          ),
                                      },
                                    },
                                  );
                                }
                              : undefined
                          }
                          overlay1CtaInactive={false}
                          overlay1CtaDisabled={loading[account.id]}
                          overlay1CtaLoading={loading[account.id]}
                          overlay2Text={
                            account.approval_status === "rejected" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? account.rejection_reason
                              : undefined
                          }
                          overlay2Subtext={
                            account.approval_status === "rejected" &&
                            account.error === "false" &&
                            !loading[account.id]
                              ? "Rejected reason"
                              : undefined
                          }
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : noTransactionsFromAPI ? (
              <div className="BeneAccount_NoAccountFound">
                <div className="BeneAccount_RightTextContentNoAccount">
                  <img
                    src={ICONS?.NO_DATA_FOUND}
                    alt=""
                  />
                </div>

                <div className="BeneAccount_LeftTextContentNoAccount_acc">
                  <p>There are no more accounts that</p>
                  <p>require your approval.</p>

                  <button
                    className="bene-acc-home-dashboard-btn"
                    onClick={() => navigate("/home")}
                  >
                    Home dashboard
                  </button>
                </div>
              </div>
            ) : null}
          </div>
          {!noResultsAfterFilter && !noTransactionsFromAPI && (
            <div
              className={`w-width-full bottom-bottom-base fixed ${
                accumulatedData?.length ===
                  GlobalConfiguration.lengthCheckZero &&
                filteredData?.length === GlobalConfiguration.lengthCheckZero &&
                !loading
                  ? "hidden"
                  : "block"
              } ${isSidebarOpen ? " z-z-index-base" : " z-z-index-content"}`}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"></div>
              )}
              <div
                className={`${(isSidebarOpen || showInnerSearchBar) && "  pointer-events-none"}`}
              >
                <PaginationComponent
                  handleSelect={handleSelect}
                  selectedValue={selectedValue}
                  data={mainData}
                  pageSize={pageSize}
                  dropdownOptions={dropdownOptions}
                  handlePagination={handlePagination}
                  currentPage={currentPage}
                  setIsOpen={setIsOpen}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FieldForceAccountSingleApproval;
